export default "__VITE_ASSET__u4MNOV7N__"